// const emoji = require('../../../data/emoji.json');

function escapeChar (a) {
    // let icon = emoji.find(smile => smile.icon == a);
    return "<span class='emoji'>" + a + "</span>"
}
function escapeEmoji (s) {
    return s.replace(/\p{Emoji_Presentation}/ug, escapeChar);
}

module.exports = {
    escapeEmoji
}
